import React from 'react';

function ProgressBar({ percentage, color = '#4361ee', height = '8px', showPercentage = false }) {
  return (
    <div>
      <div style={{ 
        width: '100%', 
        backgroundColor: '#e9ecef', 
        borderRadius: '4px',
        height: height,
        overflow: 'hidden'
      }}>
        <div 
          style={{ 
            height: '100%', 
            backgroundColor: color,
            width: `${percentage}%`,
            borderRadius: '4px',
            transition: 'width 0.3s ease-in-out',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1) inset'
          }}
        />
      </div>
      {showPercentage && (
        <div style={{ 
          textAlign: 'right', 
          fontSize: '12px', 
          color: '#6c757d', 
          marginTop: '4px' 
        }}>
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
}

export default ProgressBar;